import OutcomeService from 'src/modules/outcome/outcomeService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'OUTCOME_VIEW';

const outcomeViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: outcomeViewActions.FIND_STARTED,
      });

      const record = await OutcomeService.find(id);

      dispatch({
        type: outcomeViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: outcomeViewActions.FIND_ERROR,
      });

      getHistory().push('/outcome');
    }
  },
};

export default outcomeViewActions;
